import { Layout } from "@/components/layout/Layout";
import { Card } from "@/components/ui/card";

const CULTURAL_IMG =
  "https://images.unsplash.com/photo-1655981654045-5c45b14f3bc2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHx6aW1iYWJ3ZSUyMHN0b25lJTIwcnVpbnN8ZW58MHx8fHwxNzgxODEyNDY4fDA&ixlib=rb-4.1.0&q=85";

export function About() {
  return (
    <Layout>
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <p className="text-xs uppercase tracking-widest text-muted-foreground">About</p>
        <h1 className="font-display text-4xl sm:text-5xl mt-1">Why Play Tsoro?</h1>

        <div className="mt-6 rounded-2xl overflow-hidden">
          <img
            src={CULTURAL_IMG}
            alt="Stone wall of Great Zimbabwe"
            className="w-full h-64 object-cover"
            loading="lazy"
          />
        </div>

        <div className="prose prose-neutral dark:prose-invert max-w-none mt-8 space-y-5 text-foreground/85">
          <p>
            Play Tsoro is built and operated by <strong>Southern African Traders Ltd</strong>. It's a small, careful effort
            to digitise Tsoro and its sister mancala games while respecting the traditions that inspired them.
          </p>
          <p>
            Tsoro is a Zimbabwean strategy game in the wider mancala family, sometimes called <em>Fuva</em> or <em>Imbwe</em>.
            On a board of four rows of pits — usually eight pits per row — two players sow seeds around their own two rows,
            relaying when their final seed lands in an occupied pit, and capturing across the centre line when the right
            conditions are met.
          </p>
          <p>
            Mancala games are a family, not a single game. From Mozambique's <em>Ntxuva</em> to Uganda's <em>Omweso</em>,
            from Ghana's <em>Oware</em> to Tanzania's <em>Bao</em>, neighbouring regions developed distinct rules with
            different board sizes, capture mechanics and victory conditions. The Zimbabwean Standard ruleset is the only
            one currently marked <strong>Playable</strong>. The others have their full rules documented and will be added
            one engine at a time, with their own tests, before being marked playable.
          </p>
          <p>
            We try to avoid stereotypes. Where we use cultural imagery it is intended as a respectful reference, not
            decoration. If anything here misrepresents a tradition, please write to us so we can correct it.
          </p>
          <p className="text-sm text-muted-foreground border-t border-border/60 pt-4">
            © Southern African Traders Ltd · playtsoro.com · Contact: support@playtsoro.com
          </p>
        </div>
      </article>
    </Layout>
  );
}
